import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { CurrentUserService } from "./user/current-user.service";
import { locale } from "devextreme/localization";

@Component({
    selector: 'ngx-reload-on-change',
    template: ``
})
export class ReloadOnChangeComponent implements OnInit, OnDestroy {
    private changeAfdelingSubscription: Subscription;
    private changeCustomerSubscription: Subscription;
    private changeLanguageSubscription: Subscription;


    constructor(private service: CurrentUserService) { }

    ngOnInit(): void {
        this.changeAfdelingSubscription = this.service.onChangedCurrentAfdeling().subscribe((value) => {
            this.onChangeCurrentDeparment();
            this.loadData();
        });

        this.changeCustomerSubscription = this.service.onChangeCurrentCustomer().subscribe((value) => {
            this.onChangeCurrentCustomer();
            this.loadData();
        })

        this.changeLanguageSubscription = this.service.onLanguageChange().subscribe((value) => {
            this.onChangeCurrentLanguage();
        });
    }

    loadData(): void { }

    onChangeCurrentDeparment(): void { }
    onChangeCurrentCustomer(): void { }
    onChangeCurrentLanguage(): void { }

    ngOnDestroy(): void {
        this.changeAfdelingSubscription.unsubscribe();
        this.changeCustomerSubscription.unsubscribe();
        this.changeLanguageSubscription.unsubscribe();
    }
}